import playerIcon from 'assets/images/players-icon.png';
import location from 'assets/images/powerzone-map.png';
// import logoImage from 'assets/images/log-transperant-bkg.png';
import logoImage from 'assets/images/team-picture.png';
import teamIcon from 'assets/images/teamIcon.png';
import templeIcon from 'assets/images/temple.png';
import React from 'react';
import { Card, CardImg, CardText, CardTitle } from 'reactstrap';




const Dashboard = () => (
  <div className="content" style={{textAlign: "center"}}>
    {/* <MyTable /> */}
    {/* <img src={logoImage} alt="logo" className="logo" /> */}
    {/* <h5>4 Mandirs, 39 Teams, 315 Players</h5> */}
    <img src={logoImage} alt="logo" width="100%"/>

    <div>
      <Card inverse>
          <CardImg width="33%" src={templeIcon} alt="Card image cap" />
            <CardTitle>Mandirs</CardTitle>
            <CardText><h1>3</h1></CardText>
        </Card>
        <Card inverse>
          <CardImg width="33%" src={teamIcon} alt="Card image cap" />
            <CardTitle>Teams</CardTitle>
            <CardText><h1>29</h1></CardText>
        </Card>
        <Card inverse>
          <CardImg width="33%" src={playerIcon} alt="Card image cap" />
            <CardTitle>Players</CardTitle>
            <CardText><h1>244</h1></CardText>
        </Card>
    </div>

    <div className="content" >
      <h5><b>BAPS Swaminarayan Mandir</b> <br/>2500 Woodbridge Ave, Edison, NJ 08820</h5>
      <img src={location} alt="logo" width="100%"/>
    </div>
  
  </div>


);

export default Dashboard;


// WEBPACK FOOTER //
// ./src/pages/Dashboard/index.js